import { skiplinksThemes } from 'config/branding/component-themes/skiplinks-themes';
import headerHeights from 'config/branding/header-heights';
import SkiplinksMenu from '@activebrands/core-web/components/SkiplinksMenu';
import { styled } from '@activebrands/core-web/libs/styletron';
import { LayoutProps } from '@activebrands/core-web/types/layout';
import Footer from 'components/Footer';
import Header from 'components/Header';
import Banner from 'components/Header/Banner';
import { getHeaderTheme } from 'components/Header/getHeaderTheme';

const Wrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100dvh',
});

const Main = styled('main', {
    flex: '1 0 auto',
    scrollMarginTop: 'var(--height-header)',
});

const DefaultLayout = ({ children, page }: LayoutProps) => {
    const alternateHrefs = page.data?.hrefs || [];
    const transparentHeader = page?.data?.content?.transparentHeader;
    const pageContent = page?.data?.content || {};
    const theme = getHeaderTheme({
        heroTextColor: pageContent.heroContent?.[0]?.textColor,
        transparent: transparentHeader,
    });
    const banner = pageContent.banner?.[0] || {};
    const bannerTexts = banner?.texts?.map(text => text?.richText || text);
    const hasBanner = bannerTexts?.length > 0;
    const { bannerHeight, headerHeight } = headerHeights;
    const dynamicBannerHeight = hasBanner ? bannerHeight : 0;

    // Here we add 'noPageType' to 404 page if page.type is undefined
    const pageType = page.type || 'noPageType';

    // All themes on template "page" let content of the page fall behind the header
    const contentTopOfPage = ['page', 'noPageType'].includes(pageType);

    const contentOffset = `${contentTopOfPage ? 0 : headerHeight + dynamicBannerHeight}px`;

    return (
        <Wrapper $style={{ paddingTop: contentOffset }}>
            <SkiplinksMenu
                fontKeys="Miscellaneous/16_100_-1"
                $style={skiplinksThemes.default.menu}
                linkStyle={skiplinksThemes.default.link}
            />
            <Header alternateHrefs={alternateHrefs} theme={theme} />
            {hasBanner && (
                <Banner spin={banner?.spin} texts={bannerTexts} theme={banner?.theme} to={banner?.link?.url} />
            )}
            <Main role="main" id="main" tabIndex={-1}>
                {children}
            </Main>
            <Footer alternateHrefs={alternateHrefs} />
        </Wrapper>
    );
};

export default DefaultLayout;
